import courseSelection from './courseSelection'
import courseTask from './courseTask'
import taskSelection from './taskSelection'
import attendLecture from './attendLecture'
import list from './list'
import sendMessageList from './sendMessageList'
import overviewSelection from './overviewSelection'

export default {
	courseSelection,
	courseTask,
	taskSelection,
	attendLecture,
	list,
	sendMessageList,
	overviewSelection
}